/*
 * Merchant: "thursday frieght is made up" — same problem as the Front
 * Counter cards (assets/sat-contact-patch.js), but this instance is worse:
 * it doesn't just sit in a footer info card, it's baked into the REAL
 * order tracker every customer sees for their own real order. Nothing in
 * this store actually ships on a fixed weekly day, so three separate
 * spots were all asserting a "Thursday" schedule that doesn't exist:
 *
 *   1. SATComponent.prototype.orderStatusFor(at, order) — the function
 *      behind the order history / receipt tracker's status pill — labeled
 *      a CRATED order "boxed for Thursday freight" in both branches that
 *      reach that label (a real Shopify `fulfilled` status, and the
 *      no-fulfillment-yet age fallback). A customer with a real order
 *      sitting at CRATED on a Tuesday was being told, in effect, "it
 *      leaves in two days" with nothing behind that promise.
 *   2. renderVals's `restockLabel` — a live countdown ("TODAY" /
 *      "TOMORROW" / "IN Nd") to the next Thursday, shown on the Manifest
 *      page's RESTOCK stat.
 *   3. renderVals's `pageStats` for the store page — a flat "RESTOCK: THU"
 *      stat on The Southern Air Import's page header, sitting right next
 *      to the one real stat in that row (ON SHELF, this._products.length).
 *
 * Replaces (1) outright — same approach already used elsewhere in this
 * theme for a full method swap, e.g. assets/sat-board-wave-patch.js and
 * assets/sat-popup-dedupe-patch.js — with the Thursday-specific notes
 * swapped for a true, non-committal one ("boxed and staged for freight").
 * Every other branch (delivered/in transit/pulled/cancelled/unpaid/filed)
 * is untouched, copied verbatim from sat-app.js.
 *
 * Wraps renderVals once more for (2) and (3), replacing the fixed-day
 * claim with "CONTINUOUS" — the same honest, no-schedule-promised word
 * this theme's own Departures board already uses for its refresh cadence
 * ("MANIFEST BOARD 5150-C · LAST REFRESH: CONTINUOUS", snippets/
 * sat-departures.liquid), so the fix reads as this site's own voice
 * rather than a bolted-on disclaimer.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var proto = window.SATComponent.prototype;

  proto.orderStatusFor = function (at, order) {
    var st = order && order.shopifyStatus;
    if (st === 'delivered') { return { label: 'DELIVERED', color: '#4A5158', note: 'signed for', step: 4 }; }
    if (st === 'in_transit') { return { label: 'IN TRANSIT', color: '#2F6B3A', note: 'left the ramp', step: 3 }; }
    if (st === 'out_for_delivery') { return { label: 'IN TRANSIT', color: '#2F6B3A', note: 'on the van', step: 3 }; }
    if (st === 'fulfilled') { return { label: 'CRATED', color: '#2F6B3A', note: 'boxed and staged for freight', step: 2 }; }
    if (st === 'partial') { return { label: 'PULLED', color: '#B07A12', note: 'off the shelf, in Hall 2', step: 1 }; }
    if (st === 'cancelled') { return { label: 'CANCELLED', color: '#8A3521', note: 'withdrawn from the ramp', step: 0 }; }
    if (st === 'unpaid') { return { label: 'FILED', color: '#B07A12', note: 'awaiting payment', step: 0 }; }
    var days = Math.floor((Date.now() - at) / 86400000);
    if (days < 1) { return { label: 'FILED', color: '#B07A12', note: 'awaiting clerk review', step: 0 }; }
    if (days < 3) { return { label: 'PULLED', color: '#B07A12', note: 'off the shelf, in Hall 2', step: 1 }; }
    if (days < 5) { return { label: 'CRATED', color: '#2F6B3A', note: 'boxed and staged for freight', step: 2 }; }
    if (days < 12) { return { label: 'IN TRANSIT', color: '#2F6B3A', note: 'left the ramp', step: 3 }; }
    return { label: 'DELIVERED', color: '#4A5158', note: 'signed for', step: 4 };
  };

  var origRenderVals = proto.renderVals;
  proto.renderVals = function () {
    var out = origRenderVals.call(this);
    out.restockLabel = 'CONTINUOUS';
    if (Array.isArray(out.pageStats)) {
      out.pageStats.forEach(function (stat) {
        if (stat && stat.label === 'RESTOCK') { stat.value = 'CONTINUOUS'; }
      });
    }
    return out;
  };
})();
